import actionTypes from '../actionTypes';

export function successFreespinsGames(data: {}) {
  return {
    type: actionTypes.FREESPINS_GAMES_SUCCESS,
    value: data,
  };
}

export function failFreespinsWageringGames(e?: any) {
  return {
    type: actionTypes.FREESPINS_WAGERING_GAMES_FAIL,
    exception: e,
  };
}